export default "__VITE_ASSET__LbrPDLen__"